import React from "react";
import Button from "./Button";
import { navigate } from "gatsby";

function TemplateCard({item}) {

  return (
    <div className="max-w-xs rounded shadow-lg m-4 md:m-0 overflow-hidden">
      <img height="80" width="80" className="w-full h-64 object-contain mb-4 rounded-t transform hover:scale-110 transition ease-in duration-300" src={item.image} alt="template-card-img" />
      <div className="px-6 py-2 mt-4">
        <div className="font-bold text-xl mb-2">{item.title}</div>
        <p className="text-gray-700 text-base">
          {item.description}
        </p>
      </div>
      <div className="py-6 flex justify-evenly">
        <Button
          btnText="Overview"
          color="dark"
          onClick={() => navigate(item.detailsLink)}
        />
        <a
          className="px-6 py-2 text-xl rounded bg-indigo-100 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-200 
            focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border border-transparent"
          href={item.demoLink}
          target="_blank"
          rel="noreferrer"
        >
          Demo
        </a>
      </div>
    </div>
  )
}

export default TemplateCard;